import React, {useEffect, useRef, useState} from 'react';
import {useFieldArray} from "react-hook-form";
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import Button from "react-bootstrap/Button";
import {Form, Modal} from "react-bootstrap";
import AllDocInputs, {documentTypesList} from "./allDocInputs";
import { v4 as uuidv4 } from "uuid";
import axios from "../../../helpers/axios";
import sayError from "../../../helpers/sayError";
import _ from "lodash"
import {CopyToClipboard} from "react-copy-to-clipboard";
import moment from "moment";
import {useLocation} from "react-router-dom";
import {current} from "@reduxjs/toolkit";


const documentTempData = {
  firstName:'',
  lastName:'',
  middleName:'',
  documentNumber:'',
  expirationDate: '',
  issueDate: '',
  country: process.env.REACT_APP_DEFAULT_COUNTRY,
  gender:'',
  infant:false,
  documentType:'passport',
  photos: [],
}

const findCustomIdByDocNumber = (docNumber, fields) =>{
  if(docNumber){
    return _.find(fields, {documentNumber : docNumber})?.customId
  }
}

const CreateEditDocuments = ({dataDocs, formController, clientId}) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search)
  const {
    formState:{errors},
    getValues,
    trigger,
    control,
    watch} = formController
  const [countries, setContries] = useState(false)
  const [localClientId, setLocalClientId] = useState(clientId)
  const [firstLoading, setFirstLoading] = useState(true)
  const [copiedStatus, setCopiedStatus] = useState(false)
  const [show, setShow] = useState(false)
  const documentsControl = useFieldArray({
    control,
    name: `documents`,
    keyName: 'customId',
    shouldUnregister: false
  });
  const values = watch('documents')
  const controlledFields = documentsControl.fields.map((field, index) => ({
    ...field,
    ...values?.[index]
  }))
  const fields = controlledFields
  const prevLength = useRef(controlledFields.length)
  const [activeId, setActiveId] = useState(findCustomIdByDocNumber(params.get('doc'), fields))


  useEffect(() => {
    if(clientId !== localClientId) {
      setLocalClientId(clientId)
      setFirstLoading(true)
    }
  }, [clientId]);

  useEffect(() => {
    if (fields.length > prevLength.current && !firstLoading && clientId !== localClientId) {
      const newItem = fields[fields.length - 1]
      setActiveId(newItem.customId)
    }
    prevLength.current = fields.length
  }, [fields])

  useEffect(() => {
    axios.post('/api/locations/countries/searchInput')
      .then(({data}) => {
        setContries(data.data)
      })
      .catch(sayError)
    if(firstLoading){
      dataDocs.forEach(doc=>{
        doc.photos = doc.photos.map(photo=>({url:photo}))
      })
      documentsControl.replace(dataDocs)
    }
  }, [])

  const addNew = () =>{
    setFirstLoading(false)
    const customId= uuidv4()
    documentsControl.append({...documentTempData, customId})
    setActiveId(customId)
  }
  const removeDoc = (index) =>{
    if(window.confirm('Вы уверены, что хотите удалить документ?')){
      documentsControl.remove(index)
    }
  }

  const handleClose = async (index) => {
    const isValid = await trigger([`documents[${index}]`]);
    const ignoredFields = [
      "country",
      "infant",
      "documentType",
      "customId"
    ];
    const rePaintLinkAndClose = () =>{
      setActiveId()
      localClientId && window.history.pushState({}, null, `/counterparty/contacts?id=${clientId}`)
    }
    const isEmpty = Object.entries(getValues().documents[index])
      .filter(([key]) => !ignoredFields.includes(key) )
      .every(([, value]) => {
        if (Array.isArray(value)) return value.length === 0;
        return !value;
      });
    if (isValid) {
      rePaintLinkAndClose()
    } else if(isEmpty){
      setActiveId()
      documentsControl.remove(index)
    }else{
      if(window.confirm('Необходимо заполнить все поля. Все равно выйти?')){
        rePaintLinkAndClose()
      }
    }
  };
  const openDoc = (id,documentNumber) =>{
    setFirstLoading(false)
    setActiveId(id)
    localClientId && documentNumber &&
      window.history.pushState({}, null, `/counterparty/contacts?id=${clientId}&doc=${documentNumber}`)
  }
  useEffect(() => {
    if( fields.length >0 && firstLoading && params.get('doc')){
      const currentDoc = _.find(fields, {documentNumber : params.get('doc')})
      if(currentDoc){
        openDoc(currentDoc.customId, currentDoc.documentNumber)
      }
    }

  }, [fields]);
  const countOfExpired = _.filter(controlledFields, (data)=> moment(data.expirationDate, 'DD.MM.YYYY').isBefore(moment())).length
  return (
    <>
      <Portlet>
        <PortletHeader title={'Документы'} toolbar={<PortletHeaderToolbar >
          {countOfExpired > 0?<Form.Label className={'d-flex align-items-center gap-2 mb-0'}>
            Просроченные ({countOfExpired})
            <input
              checked={show}
              onChange={(e) => {
                setShow(!show)
              }}
              type={"checkbox"}
            />
          </Form.Label>:''}
          <Button size={'sm'} onClick={addNew} className={'ml-2'}>
            <i className="la la-plus"/>
            Добавить
          </Button>
        </PortletHeaderToolbar>}/>
      </Portlet>

      {controlledFields.map((data, index) => {
        const expired = moment(data.expirationDate, 'DD.MM.YYYY').isBefore(moment())
        const display = ((expired && show) || !expired) ?'block': 'none'
        return <div key={index} style={{display}}>
          <Portlet className={'pointer'} onClick={() => openDoc(data.customId, data.documentNumber)}>
            <PortletBody style={{ position:'relative'}}>
              {expired && <div style={{position: 'absolute',top:2, left:2, zIndex:10}}>
                <img
                  alt={'overdue'}
                  style={{width: '9rem', opacity:0.7}}
                  src={'https://png.pngtree.com/png-clipart/20230804/original/pngtree-overdue-overdue-word-sign-vector-picture-image_9574716.png'}
                />
              </div>}
              <div className={'d-flex gap-2'}>
                {data.photos.length > 0 && <img alt={'docImage'}
                                                style={{
                                                  minWidth: 100,
                                                  width:100,
                                                  height: 100,
                                                  zIndex:1,
                                                  position:'relative',
                                                  objectFit: 'cover',
                                                  borderRadius:10,
                                                  filter:expired? 'grayscale(100%)': "none",
                                                }}
                                                src={data.photos[0].url}/> }
                <div>
                  <div className={'d-flex align-items-center justify-content-between mb-3'}>
                    <div>
                      {_.find(documentTypesList, {value: data.documentType}).label} — {data.documentNumber}
                      {data.documentType === 'visa' ?
                        ` — ${_.find(countries, {value: data.country})?.label || ''} до ${data.expirationDate}` :
                        ''}
                    </div>
                    <div className={'d-flex gap-2'}>
                      <Button size={'sm'}
                              variant={'outline-secondary'}
                              onClick={() => openDoc(data.customId, data.documentNumber)}>
                        Открыть
                      </Button>
                      <Button size={'sm'} variant={'outline-danger'}
                              onClick={(e)=> {
                        e.stopPropagation();
                        removeDoc(index)
                      }}>
                        <i className="fa fa-trash"/>
                      </Button>
                    </div>
                  </div>
                  {data.amadeusString &&
                    <CopyToClipboard text={data.amadeusString} onCopy={(e)=>{
                      setCopiedStatus(data.customId)
                      setTimeout(()=>{
                        setCopiedStatus()
                      },3000)
                    }}>
                      <div className={'pointer d-flex align-items-center gap-2'} onClick={(e) => {
                        e.stopPropagation();
                      }}>
                        <i className={copiedStatus === data.customId ? "fa fa-check-circle text-success" : "fa fa-clone"}/>
                        {data.amadeusString}
                      </div>
                    </CopyToClipboard>}
                </div>

              </div>


            </PortletBody>
          </Portlet>
          <Modal show={activeId === data.customId}
                 unmountOnExit={false}
                 mountOnEnter={true}
                 dialogClassName="modal-90w"
                 onHide={()=>{handleClose(index)}}>
            <Modal.Header closeButton>
              <Modal.Title>{'Редактировать документ'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <AllDocInputs data={data}
                            formController={formController}
                            clientId={localClientId}
                            countries={countries}
                            prefix={`documents[${index}].`}/>
            </Modal.Body>
          </Modal>
        </div>
      })}


    </>
  );

};

export default CreateEditDocuments;
